import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";
import {CaCollectionParamsFilterModel} from "../models/search-params/filters/ca-collection-params-filter.model";
import {CollectionSearchParamsFactoryService} from "../services/factories/collection-search-params-factory.service";
import {CollectionFilterBaseForm} from "./collection-filter-base.form";

export class CaCollectionFilterForm extends CollectionFilterBaseForm<CaCollectionParamsFilterModel> {
    public collection: ProductCollectionsEnum  = ProductCollectionsEnum.CA;

    public get karyotype(): AbstractControl {
        return this.formInstance.get("karyotype");
    }

    public get chromosomeAffectedA(): AbstractControl {
        return this.formInstance.get("chromosomeAffectedA");
    }

    public get chromosomeAffectedB(): AbstractControl {
        return this.formInstance.get("chromosomeAffectedB");
    }

    public get chromosomeAffectedC(): AbstractControl {
        return this.formInstance.get("chromosomeAffectedC");
    }

    public get ageMin(): AbstractControl {
        return this.formInstance.get("ageMin");
    }

    public get ageMax(): AbstractControl {
        return this.formInstance.get("ageMax");
    }

    public static createForm(
        formBuilder: FormBuilder, initialValues: CaCollectionParamsFilterModel,
        searchParamsFactory: CollectionSearchParamsFactoryService
    ): CaCollectionFilterForm {

        const form = formBuilder.group({
            karyotype: [initialValues.karyotype],
            chromosomeAffectedA: [initialValues.chromosomeAffectedA],
            chromosomeAffectedB: [initialValues.chromosomeAffectedB],
            chromosomeAffectedC: [initialValues.chromosomeAffectedC],
            ageMin: [initialValues.ageMin],
            ageMax: [initialValues.ageMax]
        });

        return new CaCollectionFilterForm(form, initialValues, searchParamsFactory);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: CaCollectionParamsFilterModel,
        searchParamsFactory: CollectionSearchParamsFactoryService
    ) {
        super(formInstance, initialValues, searchParamsFactory);
    }

    protected createChangeSubscription(): Observable<CaCollectionParamsFilterModel> {
        return merge(
            this.karyotype.valueChanges.pipe(
                map((karyotype: string) => ({karyotype}))
            ),
            this.chromosomeAffectedA.valueChanges.pipe(
                map((chromosomeAffectedA: string) => ({chromosomeAffectedA}))
            ),
            this.chromosomeAffectedB.valueChanges.pipe(
                map((chromosomeAffectedB: string) => ({chromosomeAffectedB}))
            ),
            this.chromosomeAffectedC.valueChanges.pipe(
                map((chromosomeAffectedC: string) => ({chromosomeAffectedC}))
            ),
            this.ageMin.valueChanges.pipe(
                map((ageMin: number) => ({ageMin}))
            ),
            this.ageMax.valueChanges.pipe(
                map((ageMax: number) => ({ageMax}))
            )
        )
        .pipe(
            map(partialModel => this.getModel(partialModel))
        );
    }
}
